import React, { useEffect, useRef, useState } from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from '@xyflow/react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';
import { setSidebarData, setSidebarOpen, setSidebarType } from '../../../redux/slices/connectorSlice';
import '../canvas.css';

export default function FigmaEdge(props) {
  const {
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    markerEnd,
    source,
    target,
  } = props;
  const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);
  const hideTimeoutRef = useRef(null);

  // Smooth bezier path for curved connections (handles branching/merging cleanly)
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  useEffect(() => {
    return () => {
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
      }
    };
  }, []);

  const showButton = () => {
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = null;
    }
    setIsHovered(true);
  };

  const hideButton = () => {
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
    }

    hideTimeoutRef.current = setTimeout(() => {
      setIsHovered(false);
      hideTimeoutRef.current = null;
    }, 90);
  };

  const handleAddNodeInMiddle = (event) => {
    event.preventDefault();
    event.stopPropagation();

    dispatch(setSidebarOpen(true));
    dispatch(setSidebarData({
      edgeId: id,
      sourceNodeId: source,
      targetNodeId: target,
      insertPosition: { x: labelX, y: labelY },
    }));
    dispatch(setSidebarType('insertNode'));
  };

  const baseStroke = '#cbd5e1'; // slate-300 neutral
  const edgeStyle = {
    stroke: isHovered ? '#94a3b8' : baseStroke,
    strokeWidth: isHovered ? 2.5 : 2,
    fill: 'none',
    strokeLinecap: 'round',
    transition: 'stroke .15s ease, stroke-width .15s ease',
    ...style,
  };

  return (
    <>
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth="36"
        strokeLinecap="round"
        pointerEvents="stroke"
        className="edge-hover-area"
        onMouseEnter={showButton}
        onMouseMove={showButton}
        onMouseLeave={hideButton}
      />
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={{ ...edgeStyle, pointerEvents: 'none' }} />
      <EdgeLabelRenderer>
        <div
          className="edge-inline-control nodrag nopan"
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: 'all',
          }}
          onMouseEnter={showButton}
          onMouseLeave={hideButton}
        >
          <Button
            type="text"
            shape="circle"
            size="small"
            icon={<PlusOutlined />}
            onClick={handleAddNodeInMiddle}
            className={`edge-hover-button ${isHovered ? 'is-visible' : ''}`}
          />
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
